/* eslint-disable max-len */

import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';
import { useOnClickOutside } from '../../../../../../CommonMethods/OutsideClick';
import VitalBloodGlouseExport from '../Export';
import FilterObserverBtn from '../Filter';
import { handleSidebarPrvState } from '../../../../../../redux/systemConfigSlice';
import GlobalContext from '../../../../../../components/Context/GloablContext';
import { resetDeviceAlertDashboardSearch } from '../../../../../../redux/deviceAleartDashboardSlice';


const BloodGlouseVitalTopBar = ({
    SearchInput,
    AddButton,
    menuBar,
    wellnessDetails,
    handleApplyFilter,
    buttonName,
    ApplyFilter,
    setFilterValues,
    filterValues,
    initialState,
    SearchPlaceholder,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    username,
    toAddScreen,
    isExportList,
    isExport,
    setConfirmationState, 
    data, 
    exportVitalDetails, 
    isIdexport, 
    isFilterOrganization,
    vitalTabName,
    isFilterOpen,
    setIsFilterOpen,
    device,
    listingBasePath,
    TotalCount,
    deviceReadingSearch,
    listingState,
}) => {

    const [searchParams] = useSearchParams()
    const outSideClick = useRef();
    const filtervals = useSelector(state => state.systemConfigData.filterState)
    const {isSideBar,setToastmessage,setToastErrorMessage, setIsSearchOpen, isSearchOpen, setIsSideBar} = useContext(GlobalContext);
    const dispatch = useDispatch()
    const [showReadings, setShowReadings] = useState(false);
    const [dateError, setdateError] = useState(false)
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })

    const handleOpenFilter = () => {
        setdateError(false)
        if (isFilterOrganization) {
            if ((searchParams.get("start_date") !== null || searchParams.get("end_date") !== null) && !isFilterOpen) {
                setFilterValues(filtervals)

            }
            else if (searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
                setFilterValues({
                    "filter_start_date": '',
                    "filter_end_date": '',
                })
            }

        } else {
            if ((searchParams.get("field") !== null || searchParams.get("action") !== null || searchParams.get("start_date") !== null || searchParams.get("end_date") !== null) && !isFilterOpen) {
                setFilterValues(filtervals)
            }
            else if (searchParams.get("field") === null && searchParams.get("user_name") === null && searchParams.get("action") === null && searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
                setFilterValues({
                    "filter_start_date": '',
                    "filter_end_date": '',
                })
            }
        }

        setIsFilterOpen(!isFilterOpen)
    }

    // Function to handle onClick logic
    const handleSearchClick = () => {  
        dispatch(handleSidebarPrvState(isSideBar));
        setIsSearchOpen(true);
        setIsSideBar(false);
    };
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowReadings(true);
        }, 1000); // Adjust timeout duration as needed
    
        return () => clearTimeout(timer); // Cleanup on unmount
    }, []);

    return (
        <div className="mb-[14px]">
            <div className="flex items-center justify-between relative">
                {<Link
                    to={`${listingBasePath ?? '/manage-patients'}/view-patient/${location?.pathname?.split('/')?.[3]}`}
                    state={{ tab: device===undefined?'vital_screen':'device_screen', listingState: listingState ?? '' }}
                    className='items-center min-w-max flex'
                    onClick={() => { dispatch(resetDeviceAlertDashboardSearch()),
                    setIsSearchOpen(false)}}
                >
                    <span><img loading='lazy' decoding='async' src="/images/back_button_Green.svg" alt="icon" /></span>
                    <span className='text-sm font-normal text-[#008586] ml-3'>{'Go back to View Patient'}</span>
                </Link>}
                {data?.total_count!==0&&<h1 className={`${isSideBar? 'text-xl':'xl:text-xl text-[17px]'} font-normal text-[#000000] 2xl:self-center 2xl:pt-0 pt-2 self-start min-w-fit`}>{device===undefined?'List of Vital Reading History':'List of Device Reading History'}</h1>}
                <div className='flex'>
                    {deviceReadingSearch &&
                    <button 
                        id='search-btn'
                        type='button'
                        onClick={() => handleSearchClick()}
                        className="border border-[#972E4C] rounded-[15px] px-[11px] py-[11px] min-w-max">
                        <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" />
                    </button>
                    }
                    {(ApplyFilter !== undefined && ApplyFilter) &&
                    <FilterObserverBtn
                        dateError={dateError}
                        setdateError={setdateError}
                        isFilterOpen={isFilterOpen}
                        setIsFilterOpen={setIsFilterOpen}
                        handleApplyFilter={handleApplyFilter}
                        filterValues={filterValues}
                        setFilterValues={setFilterValues}
                        initialState={initialState}
                        handleOpenFilter={handleOpenFilter} />
                    }
                    {data !== undefined && data?.historical_reading?.length > 0 && <div>  <VitalBloodGlouseExport
                        exportVitalDetails={exportVitalDetails}
                        isExportList={isExportList}
                        exportCols={exportCols}
                        setIsFilterOpen={setIsFilterOpen}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                        isIdexport={isIdexport} 
                        username={username}
                        vitalTabName={vitalTabName}     
                        device={device}       
                        TotalCount={TotalCount}         
                    /> </div>}
                </div>
            </div>
            {!showReadings ? (
                <div className="animate-pulse bg-gray-300 h-5 w-[450px] rounded-md"></div>
            ) : (
                wellnessDetails?.patientData?.wellness_reading_count !== '-' && (
                    <p className="text-[14px] leading-[20px] text-[#031624] font-normal">
                        {`Current Readings Days = ${wellnessDetails?.patientData?.wellness_reading_count}, ${wellnessDetails?.patientData?.vital_pending_days} Days left in cycle (Minimum ${wellnessDetails?.patientData?.vital_number_of_time_periods} in ${wellnessDetails?.patientData?.vital_time_period} )`}
                    </p>
                )
            )}
        </div>
    );
}

export default BloodGlouseVitalTopBar;
